/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-22 07:56:13
 **/

import { create } from "zustand/react";
import { immer } from "zustand/middleware/immer";

type WindowSizeStates = {
	width: number;
	height: number;
};

type WindowSizeActions = {
	set_window_size: (width: number, height: number) => void;
};

const WindowSizeDefaultState: WindowSizeStates = {
	width: 0,
	height: 0
};

const useWindowSize = create(
	immer<WindowSizeStates & WindowSizeActions>((set) => ({
		...WindowSizeDefaultState,
		set_window_size: (width: number, height: number) => set({ width, height })
	}))
);
export default useWindowSize;
